import { Box } from '@mui/material';

import { SCUIContent } from '@/atomic/organisms/SCUIContent/SCUIContent';

import { PP } from './paylensPayment.classes';

const PAYLENS_PAYMENT_TEST_URL = 'https://paylens-preprod.lcwaikiki.com/paylens/service/chat.html';
const PAYLENS_PAYMENT_PROD_URL = 'https://checkout.hq.lcwecomtr.com/paylens/service/chat.html';

const getPaylensPaymentUrl = (): string => {
    const envName = (import.meta.env.VITE_ENVIRONMENT || '').toString().toLowerCase();

    if (envName === 'prod' || envName === 'master') {
        return PAYLENS_PAYMENT_PROD_URL;
    }

    return PAYLENS_PAYMENT_TEST_URL;
};

export const PaylensPayment = () => {
    const iframeSrc = getPaylensPaymentUrl();

    return (
        <SCUIContent className={PP.page}>
            <Box
                className={PP.frameCard}
                sx={{
                    width: '100%',
                    height: '100%',
                    minHeight: 'calc(100vh - 160px)',
                    borderRadius: 2,
                    overflow: 'hidden',
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                }}
            >
                <Box
                    className={PP.iframe}
                    component="iframe"
                    title="Paylens Payment"
                    src={iframeSrc}
                    sx={{ width: '100%', height: '725px', border: 0 }}
                />
            </Box>
        </SCUIContent>
    );
};
